"use strict";

angular.module("diceApp").filter("slimNumber", function (numberFilter) {
  return function (value, amount) {
    const text = numberFilter(value, amount);
    if (!text) {
      return text;
    }

    return parseFloat(text).toString();
  };
});
